import React, { Component } from 'react'
import getPreSignedURLForImageService from '../../Services/Queries/getPreSignedURLForImageService'
import AwsConfig from '../../Config/AwsConfig'
import Preview from './Preview'
import { Button, Modal } from 'react-bootstrap'
import FlipToStoryContent from './FlipToStoryContent'
import OnlyCoverContent from './OnlyCoverContent'
import InAppBrowserContent from './InAppBrowserContent'
export default class CoverStoryDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      coverStoryTypes: [
        {
          item: 'FlipToStory',
          id: 1,
        },
        {
          item: 'OnlyCover',
          id: 2,
        },
        {
          item: 'InAppBrowser',
          id: 3,
        },
      ],
      coverStoryType: 'FlipToStory',
      flipToStoryDetails: {},
      onlyCoverDetails: {},
      inAppBrowserDetails: {},
      isInAppBrowserEdited: false,
      isOnlyCoverEdited: false,
      isFlipToStoryEdited: false,
      modalVisible: false,
      changeToType: '',
      getDataFromChilds: false,
    }
    this.flipToStory = {}
    this.onlyCover = {}
    this.inAppBrowser = {}
  }

  handleCoverStoryType = (val) => {
    this.setState({ selectedCoverStoryType: val })
  }

  checkFlipStoryValidations = (flipToStory) => {
    const { contentSelectedLangVal } = this.props
    const fsTitle = flipToStory && flipToStory[`coverStoryTitle_${contentSelectedLangVal}`] != ''
    const fsCardDesc =
      flipToStory && flipToStory[`coverStoryCardDescription_${contentSelectedLangVal}`] != ''
    const fsImages = flipToStory.coverStoryImages && flipToStory.coverStoryImages != []
    const fsCardImages = flipToStory.coverStoryCardImages && flipToStory.coverStoryCardImages != ''
    const fsTitleOptions =
      flipToStory.textColor || flipToStory.backGroundTitle || flipToStory.contentTitlePosition
    const textValidations = fsTitle || fsCardDesc || fsTitleOptions
    const imageValidations = fsImages || fsCardImages
    return textValidations || imageValidations
  }

  checkOnlyCoverValidations = (onlyCover) => {
    const { contentSelectedLangVal } = this.props
    const csTitle = onlyCover && onlyCover[`coverStoryTitle_${contentSelectedLangVal}`] != ''
    const csImages = onlyCover.coverStoryImages && onlyCover.coverStoryImages != []
    const csTitleOptions =
      onlyCover.textColor || onlyCover.backGroundTitle || onlyCover.contentTitlePosition
    return csTitle || csImages || csTitleOptions
  }

  checkInAppBrowserValidations = (inAppBrowser) => {
    const { contentSelectedLangVal } = this.props
    const inAppTitle =
      inAppBrowser && inAppBrowser[`coverStoryTitle_${contentSelectedLangVal}`] != ''
    const inAppImages = inAppBrowser.coverStoryImages && inAppBrowser.coverStoryImages != []
    const inAppLink = inAppBrowser.link && inAppBrowser.link != ''
    const inAppLinkText = inAppBrowser.linkText && inAppBrowser.linkText != ''
    const inAppTitleOptions =
      inAppBrowser.textColor || inAppBrowser.backGroundTitle || inAppBrowser.contentTitlePosition
    const textValidations = inAppTitle || inAppLink || inAppLinkText
    const imageValidations = inAppImages
    return textValidations || imageValidations || inAppTitleOptions
  }

  checkValidations = (type) => {
    const { flipToStory, onlyCover, inAppBrowser } = this
    if (type == 'FlipToStory') {
      return this.checkFlipStoryValidations(flipToStory)
    } else if (type == 'OnlyCover') {
      return this.checkOnlyCoverValidations(onlyCover)
    } else if (type == 'InAppBrowser') {
      return this.checkInAppBrowserValidations(inAppBrowser)
    }
    return false
  }
  updateChildElements = async (key, value, type) => {
    if (type == 'FlipToStory') {
      this.flipToStory[key] = value
    } else if (type == 'OnlyCover') {
      this.onlyCover[key] = value
    } else if (type == 'InAppBrowser') {
      this.inAppBrowser[key] = value
    }
    this.props.updateInParent(key, value, 'CoverStory', type)
  }
  handleModal = () => {
    this.setState({ modalVisible: false })
  }
  resetCoverStoryContent = () => {
    const { changeToType } = this.state
    this.flipToStory = {}
    this.onlyCover = {}
    this.inAppBrowser = {}
    this.props.resetCoverStoryContent()
    this.setState({ coverStoryType: changeToType })
    this.handleModal()
  }
  changeCoverStoryType = async (currentType, type) => {
    if (currentType != type) {
      if (this.checkValidations(currentType)) {
        this.setState({ modalVisible: true, changeToType: type })
      } else {
        this.setState({ coverStoryType: type })
      }
    }
  }
  componentDidMount() {
    const { editContent } = this.props
    const { coverStoryType } = this.props.coverStoryDetails
    if (editContent) {
      const coverStoryTypeVal = coverStoryType ? coverStoryType : 'FlipToStory'
      this.setState({ coverStoryType: coverStoryTypeVal })
    }
  }
  renderCoverStoryTypes = (coverStoryType) => {
    const { getDataFromChilds } = this.state

    const { editContent, contentSelectedLangVal } = this.props
    const {
      flipToStoryDetails,
      onlyCoverDetails,
      inAppBrowserDetails,
    } = this.props.coverStoryDetails
    switch (coverStoryType) {
      case 'FlipToStory':
        return (
          <FlipToStoryContent
            editContent={this.props.editContent}
            flipToStoryDetails={editContent ? flipToStoryDetails : this.flipToStoryDetails}
            getDataFromChilds={getDataFromChilds}
            updateChildElements={(key, value, type) => this.updateChildElements(key, value, type)}
            contentSelectedLangVal={contentSelectedLangVal}
            updateVideodetails={this.props.updateVideodetails}
            contentID={this.props.contentID}
          />
        )
      case 'OnlyCover':
        return (
          <OnlyCoverContent
            editContent={this.props.editContent}
            onlyCoverDetails={editContent ? onlyCoverDetails : this.onlyCoverDetails}
            getDataFromChilds={getDataFromChilds}
            updateChildElements={(key, value, type) => this.updateChildElements(key, value, type)}
            contentSelectedLangVal={contentSelectedLangVal}
            updateVideodetails={this.props.updateVideodetails}
            contentID={this.props.contentID}
          />
        )
      case 'InAppBrowser':
        return (
          <InAppBrowserContent
            editContent={this.props.editContent}
            inAppBrowserDetails={editContent ? inAppBrowserDetails : this.inAppBrowserDetails}
            getDataFromChilds={getDataFromChilds}
            updateChildElements={(key, value, type) => this.updateChildElements(key, value, type)}
            contentSelectedLangVal={contentSelectedLangVal}
          />
        )
      default:
        return <div></div>
    }
  }
  render() {
    const { coverStoryType, coverStoryTypes, subContentExpanded, modalVisible } = this.state

    return (
      <div class='row col-md-9'>
        <div class='content'>
          <Modal show={modalVisible} onHide={() => this.handleModal()}>
            <Modal.Body>All The Changes Will Be Discarded</Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.handleModal()}>Cancel</Button>
              <Button onClick={() => this.resetCoverStoryContent()}>Ok</Button>
            </Modal.Footer>
          </Modal>
          <div class='content-type-elements'>
            {coverStoryTypes.map((item, index) => (
              <div style={{ marginRight: 10 }}>
                <input
                  value={coverStoryType}
                  type='radio'
                  checked={coverStoryType == item.item}
                  onChange={() => {
                    this.changeCoverStoryType(coverStoryType, item.item)
                  }}
                ></input>
                <text for={item.item}>{item.item}</text>
              </div>
            ))}
          </div>
          {this.renderCoverStoryTypes(coverStoryType)}
        </div>
      </div>
    )
  }
}
